import React from "react";
import Modal from "../../components/ui/Modal";
import FormMoreInfo from "../../components/FormMoreInfo/FormMoreInfo";

const ModalMoreInfoSerp = ({
  modalBusinessInfo,
  setModalBusinessInfo,
  onLocalSearchSubmit,
  location,
}) => {
  const handleSubmit = async (data) => {
    await onLocalSearchSubmit(location, data);
  };

  return (
    <Modal
      title="Encore une petite étape"
      visible={modalBusinessInfo}
      onClose={() => setModalBusinessInfo(false)}
    >
      <FormMoreInfo onSubmit={handleSubmit} />
    </Modal>
  );
};

export default ModalMoreInfoSerp;
